import { CancelClaimModalProps } from './types'
import { Button, Content, StyledModal } from './styles'

function CancelClaimModal({
  isModalOpen,
  claimNumber,
  onClose,
  onConfirm,
  isLoading = false,
}: CancelClaimModalProps) {
  const modalContent = {
    title: 'ยืนยันยกเลิกเคสเคลมประกันสุขภาพและอุบัติเหตุ',
    content: 'เมื่อยกเลิกระบบจะบันทึกเคสนี้ให้เป็นเคสยกเลิกแบบ CE (Cancelled with error)',
    confirmText: 'ยืนยัน',
    cancelText: 'ยกเลิก',
  }

  return (
    <StyledModal
      open={isModalOpen}
      closable={false}
      onCancel={onClose}
      title={modalContent.title}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={isLoading}>
          {modalContent.cancelText}
        </Button>,
        <Button
          key="confirm"
          type="primary"
          onClick={onConfirm}
          loading={isLoading}
          disabled={isLoading}
        >
          {modalContent.confirmText}
        </Button>,
      ]}
    >
      <Content>{modalContent.content}</Content>
    </StyledModal>
  )
}

export default CancelClaimModal
